// src/pages/HomePage.js - Fixed version
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Layout, Row, Col, Typography, Button, Tag, Space, Alert, Card } from 'antd';
import LocationSearchBox from '../components/LocationSearchBox';
import FeaturedShops from '../components/FeaturedShops';

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

const HomePage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleLocationSearch = async (searchLocation) => {
        try {
            setIsLoading(true);
            setError(null);

            navigate(`/shops?location=${encodeURIComponent(searchLocation)}`);
        } catch (err) {
            console.error('Fehler bei der Weiterleitung:', err);
            setError('Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Layout>
            <Helmet>
                {/* <title>Snus Finder | Finde Snus-Verkaufsstellen in deiner Nähe</title> */}
                <title>Snus Verzeichnis Deutschland: Finde Shops & Läden in deiner Nähe | Snus Finder</title>
                {/* <meta name="description" content="Finde Geschäfte, Tankstellen und Kioske, die Snus in deiner Nähe verkaufen. Die größte Datenbank für Snus-Verkaufsstellen in Deutschland." /> */}
                <meta name="description" content="Das erste Verzeichnis für Snus in Deutschland. Finde alle Läden, Kioske und Tankstellen in deiner Nähe, die Snus und Nikotin Pouches verkaufen." />
                {/* <meta name="keywords" content="snus kaufen, snus in der nähe, wo kann ich snus kaufen, snus händler, snus tankstelle" /> */}
                {/* Strukturierte Daten für Google */}
                <script type="application/ld+json">
                    {`
            {
              "@context": "https://schema.org",
              "@type": "WebSite",
              "url": "https://www.snusfinder.de/",
              "potentialAction": {
                "@type": "SearchAction",
                "target": "https://www.snusfinder.de/shops?location={search_term}",
                "query-input": "required name=search_term"
              }
            }
          `}
                </script>
            </Helmet>

            <Content style={{ padding: '0 50px', marginTop: '30px' }}>
                {/* Hero-Bereich mit Suche */}
                <Row justify="center" align="middle" style={{ background: '#f0f2f5', padding: '50px 0', textAlign: 'center', marginBottom: '30px', borderRadius: '8px' }}>
                    <Col xs={24} sm={20} md={16} lg={12}>
                        <Title level={1}>Finde Snus in deiner Nähe</Title>
                        <Paragraph style={{ fontSize: '1.2em' }}>
                            Das größte Verzeichnis für Snus-Verkaufsstellen in Deutschland
                        </Paragraph>

                        <div style={{ margin: '20px 0' }}>
                            <LocationSearchBox onSearch={handleLocationSearch} isLoading={isLoading} />
                            {error && <Alert message={error} type="error" showIcon style={{ marginTop: '10px' }} />}
                        </div>

                        <Space direction="vertical" size="middle">
                            <Text>Beliebte Suchen:</Text>
                            <Space wrap size={[8, 8]}>
                                <Tag><Link to="/shops?location=Berlin">Snus in Berlin</Link></Tag>
                                <Tag><Link to="/shops?location=München">Snus in München</Link></Tag>
                                <Tag><Link to="/shops?location=Hamburg">Snus in Hamburg</Link></Tag>
                                <Tag><Link to="/shops?location=Köln">Snus in Köln</Link></Tag>
                                <Tag><Link to="/shops?location=Frankfurt">Snus in Frankfurt</Link></Tag>
                            </Space>
                        </Space>
                    </Col>
                </Row>

                {/* Was ist Snus? - Jetzt als Card */}
                <Row justify="center" style={{ marginBottom: '30px' }}>
                    <Col xs={24} sm={20} md={16} lg={14}>
                        <Card>
                            <Title level={2}>Was ist Snus?</Title>
                            <Paragraph>
                                Snus ist ein traditionelles skandinavisches Tabakprodukt, das ohne Verbrennung konsumiert wird.
                                Es wird meist in kleinen Portionsbeuteln angeboten und zwischen Oberlippe und Zahnfleisch platziert.
                            </Paragraph>
                            <Paragraph>
                                Neben dem klassischen Snus gibt es auch tabakfreie <Text strong>Nikotinbeutel (Nicotine Pouches)</Text>, die eine ähnliche Anwendung finden.
                            </Paragraph>
                            <Paragraph>
                                Als Alternative zu Zigaretten erfreuen sich beide Produktarten auch in Deutschland immer größerer Beliebtheit.
                                Unser Verzeichnis hilft dir, autorisierte Verkaufsstellen für Snus <Text strong>und</Text> Nikotinbeutel in deiner Nähe zu finden.
                            </Paragraph>
                        </Card>
                    </Col>
                </Row>

                {/* Empfohlene Verkaufsstellen - Jetzt als Card */}
                <Row justify="center" style={{ marginBottom: '30px' }}>
                    <Col xs={24} sm={20} md={18} lg={20}>
                         <Card>
                            <Title level={2} style={{ textAlign: 'center', marginBottom: '20px' }}>Empfohlene Verkaufsstellen</Title>
                            <FeaturedShops />
                        </Card>
                    </Col>
                </Row>

                {/* Für Shopbetreiber - Jetzt als Card */}
                 <Row justify="center" style={{ marginBottom: '50px' }}>
                    <Col xs={24} sm={20} md={16} lg={14}>
                        <Card style={{ textAlign: 'center', background: '#f0f2f5' }}>
                            <Title level={2}>Für Shopbetreiber</Title>
                            <Paragraph>
                                Sie verkaufen Snus in Ihrem Geschäft? Registrieren Sie sich in unserem Verzeichnis und erreichen Sie
                                neue Kunden, die gezielt nach Snus-Verkaufsstellen suchen.
                            </Paragraph>
                            {/* Link anpassen, falls der Registrierungslink anders lautet */}
                            <Link to="/register">
                                <Button type="primary" size="large">Als Verkaufsstelle registrieren</Button>
                            </Link>
                        </Card>
                    </Col>
                </Row>
            </Content>
        </Layout>
    );
};

export default HomePage;